(function () {
  function activate(btn) {
    var embed = btn.getAttribute('data-youtube-embed');
    if (!embed) return;
    var host = btn.closest('.amc-split__media-inner') || btn.parentNode;
    if (!host) return;

    var iframe = document.createElement('iframe');
    iframe.className = 'amc-split__iframe';
    iframe.src = embed;
    iframe.title = btn.getAttribute('aria-label') || 'Workshop video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');

    host.innerHTML = '';
    host.appendChild(iframe);
  }

  function onClick(event) {
    var btn = event.target.closest('[data-amc-split-youtube]');
    if (!btn) return;
    event.preventDefault();
    activate(btn);
  }

  function onKey(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var btn = event.target.closest('[data-amc-split-youtube]');
    if (!btn) return;
    event.preventDefault();
    activate(btn);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);
})();
